import {
  SearchSuggestionsType,
  SuggestionType
} from 'src/components/searchBox/SearchTypes';
import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';
import { DynamicObject } from 'src/utils/commonTypes';

import { debounce } from '../../utils/common';
import {
  SEARCH_LANDING_QUERY,
  SEARCH_RESULT_QUERY,
  SEARCH_RESULT_RAILS_QUERY,
  SEARCH_SUGGESTION_QUERY
} from '../GraphQL/Queries/SearchQueries';
import {
  SearchQueryInput,
  SearchSuggestionInput
} from '../GraphQL/Queries/types';
import { graphQlRequest } from '../GraphQL/RequestHandler';
import { HTTP_HEADER_KEYS } from '../../utils/constants/HttpMethodsConstants';

interface requestParamsType {
  searchSuggestionInput: SearchSuggestionInput;
}

export const getSearchLanding = async (requestObj: DynamicObject) => {
  const { city, state, country, displayLanguage, contentLanguage } = requestObj;
  const reqObj = {
    input: {
      city,
      state,
      country,
      translation: displayLanguage,
      languages: contentLanguage,
      type: 'collections'
    }
  };
  const headers = [
    HTTP_HEADER_KEYS.X_ACCESS_TOKEN,
    HTTP_HEADER_KEYS.X_Z5_GUEST_TOKEN
  ];

  try {
    const response = await graphQlRequest(
      SEARCH_LANDING_QUERY,
      reqObj,
      GQL_QUERIES.SEARCH_LANDING_QUERY,
      headers
    );
    return response;
  } catch (error) {
    console.error('Error while fetching search landing data: ', error);
    return {};
  }
};

export const getSearchSuggestion = async (
  requestObj: DynamicObject,
  headers: string[]
) => {
  const { query, country, languages } = requestObj;
  const requestParams: requestParamsType = {
    searchSuggestionInput: {
      query,
      limit: 10,
      page: 0,
      country,
      languages
    }
  };
  if (requestObj.content_appropriate_age) {
    requestParams.searchSuggestionInput.ageRating = Number(
      requestObj.content_appropriate_age
    );
  }
  try {
    const response = await graphQlRequest(
      SEARCH_SUGGESTION_QUERY,
      requestParams,
      GQL_QUERIES.SEARCH_SUGGESTION_QUERY,
      headers
    );
    return response;
  } catch (error) {
    console.error('Error while fetching movie by id: ', error);
    return {};
  }
};

export const getSearchResults = async (
  requestObj: SearchQueryInput,
  headers: string[]
) => {
  const { query, limit, page, country, languages, translation } = requestObj;

  const requestParams = {
    searchQueryInRailInput: {
      query,
      limit,
      page,
      country,
      filters: {},
      languages,
      translation
    }
  };
  try {
    const response = await graphQlRequest(
      SEARCH_RESULT_RAILS_QUERY,
      requestParams,
      GQL_QUERIES.SEARCH_RESULT_RAILS_QUERY,
      headers
    );
    return response;
  } catch (error) {
    console.error('Error while fetching movie by id: ', error);
    return {};
  }
};

export const debouncedFetchData = debounce(
  (
    query: string,
    setSuggestionResult: (suggestionResult: Array<SuggestionType>) => void,
    inMemoryCache: (
      requestObj: DynamicObject,
      headers: string[]
    ) => Promise<SearchSuggestionsType>,
    headers: string[],
    requestObj: DynamicObject
  ) => {
    fetchData(query, setSuggestionResult, inMemoryCache, headers, requestObj);
  },
  300
);

const fetchData = async (
  query: string,
  setSuggestionResult: (suggestionResult: Array<SuggestionType>) => void,
  inMemoryCache: (
    requestObj: DynamicObject,
    headers: string[]
  ) => Promise<SearchSuggestionsType>,
  headers: string[],
  requestObj: DynamicObject
) => {
  inMemoryCache(requestObj, headers).then((res: SearchSuggestionsType) => {
    if (res && res.searchSuggestions && res.searchSuggestions.suggestions)
      setSuggestionResult(res.searchSuggestions.suggestions);
  });
};
